/**
 * Pure rule that determines whether contract preview is meaningful for a TT
 * order event. Used to gate the (currently disabled) preview button so the
 * data flow is in place when we re-enable it.
 *
 * Today: HTA OR OTC Filled events.
 */
export function canPreviewContract(
  event: { event_type: string | null },
  metadata: { expected_hta?: boolean; expected_otc?: boolean } | null
): boolean {
  if (event.event_type !== "Filled") return false;
  return Boolean(metadata?.expected_hta || metadata?.expected_otc);
}
